module.exports = __webpack_public_path__ + "img/fondo_cohete_movil.e8be49db.png";